/**
 * @fileOverview Cookie module, including get , set ,remove
 * @author yichen <yichen.hww@alibaba-inc.com>
 * @version 5.0.0
 */
const Cookie = {};
const defaults = {};
/**
 * set cookie
 * @param {string} keyName
 * @param {string} keyValue
 * @param {object} options
 */
function setCookie(keyName, keyValue, options) {
  let key = keyName;
  let value = keyValue;
  const attributes = Object.assign(
    {
      path: '/',
    },
    defaults,
    options
  );

  if (typeof attributes.expires === 'number') {
    const expires = new Date();
    expires.setMilliseconds(expires.getMilliseconds() + attributes.expires * 864e5);
    attributes.expires = expires;
  }
  let result;
  // We're using "expires" because "max-age" is not supported by IE
  attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';

  try {
    result = JSON.stringify(value);
    if (/^[{[]/.test(result)) {
      value = result;
    }
  } catch (e) {
    console.log(e);
  }

  value = encodeURIComponent(String(value)).replace(
    /%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g,
    decodeURIComponent
  );

  key = encodeURIComponent(String(key));
  key = key.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent);
  key = key.replace(/[()]/g, escape);

  let stringifiedAttributes = '';

  for (const attributeName in attributes) { // eslint-disable-line
    if (!attributes[attributeName]) {
      continue; // eslint-disable-line
    }
    stringifiedAttributes += `; ${attributeName}`;
    if (attributes[attributeName] === true) {
      continue; // eslint-disable-line
    }
    stringifiedAttributes += `=${attributes[attributeName]}`;
  }
  return (document.cookie = `${key}=${value}${stringifiedAttributes}`);
}
/**
 * get cookie
 * @param {string} key , the key of cookie , if not set, will return all the cookie
 */
function getCookie(key, options = {}) {
  let result = key ? null : {};
  const cookies = document.cookie ? document.cookie.split('; ') : [];
  const rdecode = /(%[0-9A-Z]{2})+/g;

  for (let i = 0; i < cookies.length; i += 1) {
    const parts = cookies[i].split('=');
    let cookie = parts.slice(1).join('=');

    if (!options.json && cookie.charAt(0) === '"') {
      cookie = cookie.slice(1, -1);
    }

    try {
      const name = parts[0].replace(rdecode, decodeURIComponent);
      cookie = cookie.replace(rdecode, decodeURIComponent);

      if (options.json) {
        try {
          cookie = JSON.parse(cookie);
        } catch (e) {
          console.log(e);
        }
      }

      if (key === name) {
        result = cookie;
        break;
      }

      if (!key) {
        result[name] = cookie;
      }
    } catch (e) {
      console.log(e);
    }
  }
  return result;
}
Cookie.getJSON = function getJSONCookie(key, options = {}) {
  return getCookie(key, {
    json: true,
    ...options,
  });
};
Cookie.get = getCookie;
Cookie.set = setCookie;
/**
 * remove the cookie
 * @param {string} key
 * @param {object} attributes
 */
Cookie.remove = function removeCookie(key, attributes = {}) {
  setCookie(
    key,
    '',
    Object.assign(attributes, {
      expires: -1,
    })
  );
};

export default Cookie;



// WEBPACK FOOTER //
// ./src/utils/cookie.js